import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { connectLean } from 'lean-redux';
import { Link } from 'react-router';

import ResourceTypes from 'legacy/packages/unit-outline/src/constants';
import Share from './Share';
import Assign from './Assign';
import ProgressIcon from '../AssessmentProgress/ProgressIcon';
import ItemActionShare from './ItemActionShare';
import NoClassAlert from 'legacy/src/utility/NoClassAlert';
import { RESOURCES } from 'chameleon/ui-stack/utilities/copy';

import './index.scss';

const ItemAction = (props) => {
  const {
    assignmentOverview,
    item,
    userData: { isStudent },
    returnPath,
    isPreApSubject,
    hasAssignAction,
    isLinkDisabled,
    url,
    items,
  } = props;
  let action;

  if (isStudent) {
    if (props.buttonIcon) {
      return props.buttonIcon;
    }

    if (assignmentOverview && assignmentOverview.scoringCompletedAt) {
      if (isLinkDisabled) {
        return <ProgressIcon isPerformance />;
      }

      if (url) {
        return (
          <Link
            to={{
              pathname: url,
              query: { returnPath },
            }}
          >
            <ProgressIcon isPerformance />
          </Link>
        );
      }
    }

    return null;
  }

  const noClassAlert = (
    <NoClassAlert
      title=""
      description={RESOURCES.NO_CLASSES_ALERT.DESCRIPTION}
      content={RESOURCES.NO_CLASSES_ALERT.LABEL}
      withPadding={false}
    />
  );

  const hasNoClasses = !items.length;

  const actionProps = {
    ...props,
    modalTitle: 'Share Resource',
    noClassAlert,
    hasNoClasses,
  };

  switch (item.__typename) {
    case ResourceTypes.URL:
    case ResourceTypes.YOUTUBE:
    case 'Unit':
      /**
       * Do not render if the item it's not shareable
       * */
      if (!isStudent) {
        action = actionProps.item.isShareable ? (
          <Share {...actionProps}>
            <ItemActionShare className="share-icon" />
          </Share>
        ) : null;
      } else {
        action = null;
      }
      break;
    case ResourceTypes.ASSESSMENT:
      /**
       * Hide for teacher in AP
       * */
      if (!isStudent && (isPreApSubject || hasAssignAction)) {
        action = <Assign {...actionProps} />;
      } else {
        action = null;
      }
      break;
    case ResourceTypes.TEACHER_MODULE:
    case ResourceTypes.QUESTION_BANK:
    default:
      action = null;
      break;
  }

  return action;
};

ItemAction.displayName = 'ItemAction';

ItemAction.propTypes = {
  item: PropTypes.object,
  unitNumber: PropTypes.number,
  items: PropTypes.array,
  userData: PropTypes.object,
  assignmentOverview: PropTypes.object,
  isPreApSubject: PropTypes.bool,
  hasAssignAction: PropTypes.bool,
  onItemAction: PropTypes.func,
  canAssignRedirect: PropTypes.bool,
};

ItemAction.defaultProps = {
  isPreApSubject: false,
  hasAssignAction: false,
  onItemAction: () => {},
  canAssignRedirect: true,
};

function mapStateToProps(state) {
  const { userData, classes } = state;

  return {
    items: classes.items.filter(
      (item) =>
        item.educationPeriod.toString() ===
        userData.educationPeriod.currentEducationPeriod.id,
    ),
    userData,
  };
}

export default connectLean({
  mapState(state) {
    if (state.hasOwnProperty('disabled')) {
      return {
        disabled: state.disabled,
      };
    }
  },
})(connect(mapStateToProps)(ItemAction));
